import Component from '../abstracts/Component';
import AccordionMixinComponent from './mixins/AccordionMixinComponent';

export default class CountryItemComponent extends Component {
  get COMPONENTNAME() {
    return "CountryItemComponent";
  }

  get SELECTORS() {
    return {
      toggleCta: '[data-toggle]',
    };
  }

  constructor(elem) {
    super(elem);
    this.accordion = new AccordionMixinComponent(elem);
  }

  readDOM() {
    return {
      toggleCta: this.$component.querySelector(this.SELECTORS.toggleCta),
    }
  }

  bindEvents() {
    if (!this.dom.toggleCta || !this.accordion) return;
    this.dom.toggleCta.addEventListener('click', () => {
      if (this.accordion.isExpanded()) {
        this.accordion.collapse();
      } else {
        this.accordion.expand();
      }
    });
  }

  render() {
    this.accordion.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
